import { SxProps, Theme } from "@mui/material";

export function wrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: "1",
        p: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        my: "50px"
    };
}

export function cardCSS(theme: Theme): SxProps<Theme> {
    return {
      px: "4rem",
      py: "20px",
      borderRadius: "30px",
      width: { xs: "200px", md: "500px", lg: "600px" },
      minHeight: 400
    };
}

export function containerCSS(theme: Theme): SxProps<Theme> {
    return {
      backgroundColor: { xs: "#F9F9F9", sm: "transparent" },
      px: { xs: "1rem", sm: "3rem", md: "0", lg: "3rem" },
      maxWidth: { xs: "390px", sm: "500px", md: "550px" },
      textAlign: "center"
    };
}

export function infotext(theme: Theme): SxProps<Theme> {
    return {
        display: 'flex',
        justifyContent: 'space-between',
        textAlign: "justify", 
        whiteSpace: "pre-wrap",
        paddingBottom: '1.00rem'
    };
}